module.exports = __webpack_public_path__ + "static/img/code_01.d1e44c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/code_01.png
// module id = L9qS
// module chunks = 2